import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { PencilSimpleIcon } from "@phosphor-icons/react";
import { toast } from "sonner";

const FIELDS = ["name", "phone", "email", "address"];

export const GuestContactEdit = ({ guest, onSaved, testIdPrefix = "guest-contact" }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  if (!guest?.id) return null;

  const start = () => {
    setForm(Object.fromEntries(FIELDS.map((k) => [k, guest[k] || ""])));
    setOpen(true);
  };
  const save = async () => {
    if (!form.name.trim()) return toast.error("Name is required");
    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email.trim())) return toast.error("Enter a valid email");
    setBusy(true);
    try {
      const patch = Object.fromEntries(FIELDS.map((k) => [k, form[k].trim()]));
      await api.patch(`/guests/${guest.id}`, patch);
      toast.success("Contact details updated");
      setOpen(false);
      onSaved?.({ ...guest, ...patch });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Update failed");
    } finally { setBusy(false); }
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <>
      <Button type="button" size="sm" variant="ghost" className="h-7 px-2 text-xs" onClick={start} data-testid={`${testIdPrefix}-edit-btn`}>
        <PencilSimpleIcon size={12} className="mr-1" /> Edit contact
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid={`${testIdPrefix}-dialog`}>
          <DialogHeader><DialogTitle>Edit contact details</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Name</Label><Input value={form.name || ""} onChange={set("name")} data-testid={`${testIdPrefix}-name`} /></div>
            <div><Label>Phone</Label><Input value={form.phone || ""} onChange={set("phone")} data-testid={`${testIdPrefix}-phone`} /></div>
            <div><Label>Email</Label><Input type="email" value={form.email || ""} onChange={set("email")} data-testid={`${testIdPrefix}-email`} /></div>
            <div><Label>Address</Label><Textarea rows={3} value={form.address || ""} onChange={set("address")} data-testid={`${testIdPrefix}-address`} /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid={`${testIdPrefix}-cancel`}>Cancel</Button>
            <Button onClick={save} disabled={busy} data-testid={`${testIdPrefix}-save`}>{busy ? "Saving…" : "Save"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
